import { cx } from '@flowus/common/cx';
import type { FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { Tooltip } from 'src/common/components/tooltip';
import { useIsInRight } from 'src/utils/right-utils';
import { CommentTabIndex, setCommentListIndex } from 'src/views/comments/page-resolved-discussions';
import { useDrawerOpenState } from '../drawer/shared';

export const PageCommentButton: FC<{ className?: string }> = ({ className }) => {
  const [drawState, setDrawState] = useDrawerOpenState();
  const isInRight = useIsInRight();
  const hover =
    (isInRight && drawState === 'page-resolved-discussions-right') ||
    (!isInRight && drawState === 'page-resolved-discussions');
  return (
    <Tooltip
      popup={drawState ? '关闭评论列表' : '查看评论列表'}
      className={cx(
        'flex items-center justify-center animate-hover',
        hover && 'bg-black_006',
        className
      )}
      onClick={() => {
        setCommentListIndex(CommentTabIndex.UN_RESOLVE_COMMENT);
        if (isInRight) {
          setDrawState(
            drawState !== 'page-resolved-discussions-right'
              ? 'page-resolved-discussions-right'
              : false
          );
        } else {
          setDrawState(
            drawState !== 'page-resolved-discussions' ? 'page-resolved-discussions' : false
          );
        }
      }}
    >
      <Icon name={'IcCommentMiddleBold'} boxSize="large" size="small" />
    </Tooltip>
  );
};
